<template>
  <div class="form-group">
    <label :class="`col-sm-${+labelCols}`">{{ label }}</label>
    <div :class="`col-sm-${12 - +labelCols} selected-item-wrapper`">
      <button
        v-if="buttonText && !disabled"
        class="btn btn-regular"
        type="button"
        @click="selectFile"
      >
        {{ buttonText }}
      </button>
      <div>
        <div v-for="file in files" :key="file[valueField]" class="selected-item">
          <a v-if="onDownload" href="#" @click.prevent="onDownload(file)">{{ file[textField] }}</a>
          <template v-else>
            {{ file[textField] }}
          </template>
          <i v-if="onDelete && !disabled" class="icon-close" @click="deleteFile(file)"></i>
        </div>
      </div>
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
    <input
      :accept="accept"
      ref="fileInput"
      type="file"
      @change="uploadFile"
      style="display: none;"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseFileUploader',

  props: {
    accept: {
      type: String,
      default: '*',
    },
    buttonText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    files: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    labelCols: {
      type: [Number, String],
      default: 6,
    },
    onUpload: {
      type: Function,
      required: true,
    },
    onDelete: {
      type: Function,
      default: null,
    },
    onDownload: {
      type: Function,
      default: null,
    },
    textField: {
      type: String,
      default: 'filename',
    },
    valueField: {
      type: String,
      default: 'id',
    },
  },

  data() {
    return {
      deletingFiles: new Set(),
    };
  },

  methods: {
    deleteFile(file) {
      if (this.deletingFiles.has(file.id)) {
        return;
      }
      this.deletingFiles.add(file.id);
      this.onDelete(file).finally(() => {
        this.deletingFiles.delete(file.id);
      });
    },

    selectFile() {
      this.$refs.fileInput.click();
    },

    uploadFile(event) {
      const file = event.target?.files[0];
      if (!file) {
        return;
      }
      this.onUpload(file);
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 30px;
}

.selected-item {
  color: #415e72;
}

.icon-close {
  cursor: pointer;
  margin-left: 4px;
}
</style>
